import {
  utils,
} from '@ama-sdk/core';
import {
  todayPlusNdays,
} from '@dapi/sdk/helpers';
import {
  format,
  subDays,
} from 'date-fns';

const THIRTY_ONE_YEARS_IN_DAYS = 31 * 370;

const today = new Date();

export const globalDob = subDays(today, THIRTY_ONE_YEARS_IN_DAYS).toISOString();

const EIGHT_YEARS_IN_DAYS = 370 * 8;

export const globalExpiryDate = new utils.Date(todayPlusNdays('09:00', (EIGHT_YEARS_IN_DAYS))).toISOString();

const TEN_YEARS_IN_DAYS = 370 * 10;

export const globalIssuanceDate = subDays(today, TEN_YEARS_IN_DAYS);

/**
 * Formats a date to a specified format.
 *
 * @param date - The date to format (Date object or ISO string).
 * @param dateFormat - The format string (default: 'dd/MM/yyyy').
 * @returns The formatted date string.
 */
export function formatDateToString(date: Date | string, dateFormat = 'dd/MM/yyyy'): string {
  const dateObj = typeof date === 'string' ? new Date(date) : date;
  return format(dateObj, dateFormat);
}
